import EmailPinVerifyForm from './EmailPinVerifyForm';

export default EmailPinVerifyForm;
